<template>
  <iframe
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2421.312309294648!2d0.6900965!3d52.6362704!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47d82b09c4a7efad%3A0x405a6eb9c35e8afa!2sEcoSpark%20Electrical%20Ltd!5e0!3m2!1sen!2suk!4v1783413913973!5m2!1sen!2suk"
    width="100%"
    :height="height"
    style="border:0;"
    allowfullscreen=""
    referrerpolicy="no-referrer-when-downgrade"
  ></iframe>
</template>

<script>
export default {
  props: {
    height: {
      type: String,
      default: '450'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/partials/GoogleMapsEmbed.vue